/* eslint-disable no-negated-condition */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
/* eslint-disable prefer-template */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/react-in-jsx-scope */
import * as Yup from 'yup';
import DateFormatter from 'components/DateFormatter';
import { Badge } from 'reactstrap';
import UserInfo from 'components/UserInfo';
import React from 'react';
import moment from 'moment';
import { currencyToLocal, currentDatePlusDaysToEpoch } from 'utils/constants';
import CommissionTypeSelector from './components/CommissionTypeSelector';
import FlagCell from './components/FlagCell';

const getTraderTag = (row) => {
  const traderTags = row?.original?.traderTags;
  return Array.isArray(traderTags) ? traderTags[0] : traderTags;
};

const renderFlagCell = (row) => {
  const traderTag = getTraderTag(row);
  return (
    <FlagCell
      initialColor={traderTag?.colorCode}
      initialText={traderTag?.tagName}
      userId={row?.original?.id}
    />
  );
};

export const vendorValidationSchema = Yup.object({
  firstName: Yup.string('Enter the First Name')
    .required('First Name is required')
    .trim(),
  lastName: Yup.string('Enter the Last Name')
    .required('Last Name is required')
    .trim(),
  // middle_name: Yup.string().required('Middle name is required'),
  // isKycVerified: Yup.string().required('Verification status is required'),
  // country: Yup.string().required('Country is required'),
  // city: Yup.string().required('City is required'),
  // state: Yup.string().required('State is required'),
  // phone_number: Yup.number().required('Phone number is required'),
  // email: Yup.string('Enter your email')
  //   .email('Enter a valid email')
  //   .required('Email is required'),

  callingCode: Yup.object().required('Please Select Calling code'),
  phone: Yup.string()
    .required('Phone number is required')
    .matches(/^\d{8,12}$/, 'Phone number is invalid.')
    .trim(),
  // phone: Yup.string()
  //   .required('Phone number is required')
  //   .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits')
  //   .trim(),
  addresses: Yup.array().of(
    Yup.object().shape({
      pinCode: Yup.string()
        .matches(/^(\d{6})?$/, 'Pincode must be 6 digits')
        .nullable(),
      country: Yup.object('').nullable(),
      state: Yup.object('').nullable(),
      city: Yup.object('').nullable(),
      street: Yup.string('Enter the Street')
        .trim()
        .nullable(),
    }),
  ),
});

function IndeterminateCheckbox({ indeterminate, className = '', ...rest }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={className + ' cursor-pointer'}
      {...rest}
    />
  );
}
export const vendorColumns = [
  {
    id: 'select',
    header: ({ table }) => (
      <>
        <IndeterminateCheckbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
      </>
    ),
    cell: ({ row }) => (
      <div className="px-1">
        <IndeterminateCheckbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler(),
          }}
        />
      </div>
    ),
  },
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'flag',
    header: 'FLAG',
    cell: ({ row }) => renderFlagCell(row),
    enableSorting: false,
  },
  { accessorKey: 'id', header: 'ID', enableSorting: true },

  {
    accessorKey: 'firstName',
    header: 'VENDOR',
    // cell: ({ row }) => (
    //   <UserInfo
    //     name={`${row?.original?.firstName} ${
    //       row?.original?.lastName ? row?.original?.lastName : ''
    //     }`}
    //     mobileNumber={row?.original?.phone}
    //   />
    // ),
    enableSorting: true,
  },

  {
    accessorKey: 'tradeName',
    header: 'BUSINESS NAME',
    cell: ({ row }) => (
      <>
        {row?.original?.tradeName || row?.original?.entityName ? (
          <UserInfo
            name={row?.original?.tradeName || row?.original?.entityName || ''}
            gstNumber={row?.original?.tradeGstIn}
          />
        ) : (
          'N/A'
        )}
      </>
    ),
    enableSorting: true,
  },

  // {
  //   accessorKey: 'isParentTrader',
  //   header: 'Parent Trader',
  //   cell: ({ row }) => (
  //     <>
  //       {row?.original?.isParentTrader ? (
  //         'N/A'
  //       ) : (
  //         <div>
  //           {row?.original?.parentTrader?.firstName +
  //             ' ' +
  //             row?.original?.parentTrader?.lastName}
  //         </div>
  //       )}
  //     </>
  //   ),
  //   enableSorting: false,
  // },
  {
    accessorKey: 'demandCount',
    header: 'DEMAND COUNT',
    enableSorting: false,
  },
  {
    accessorKey: 'latestUserSubscription',
    header: 'PLAN',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <div
          key={row?.latestUserSubscription?.subscriptionPlan?.id}
          className="me-1"
        >
          <UserInfo
            name={row?.latestUserSubscription?.subscriptionPlan?.planName}
            gstNumber={moment(
              row?.latestUserSubscription?.deactivationDate,
            ).format('D MMM, YYYY')}
          />
        </div>
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <div key={row?.userSubscription?.subscriptionPlan?.id} className="me-1">
    //       <UserInfo
    //         name={row?.userSubscription?.subscriptionPlan?.planName}
    //         gstNumber={moment(row?.userSubscription?.deactivationDate).format(
    //           'D MMM, YYYY',
    //         )}
    //       />
    //     </div>
    //   ) : row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id ? (
    //     <div
    //       key={row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id}
    //       className="me-1"
    //     >
    //       <UserInfo
    //         name={
    //           row?.latestDeactivatedUserSubscription?.subscriptionPlan?.planName
    //         }
    //         gstNumber={moment(
    //           row?.latestDeactivatedUserSubscription?.deactivationDate,
    //         ).format('D MMM, YYYY')}
    //       />
    //     </div>
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorKey: 'latestUserSubscription?.activationDate',
    header: 'Plan Activation Date',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <DateFormatter dateTime={row?.latestUserSubscription?.activationDate} />
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <DateFormatter dateTime={row?.userSubscription?.activationDate} />
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },

  {
    accessorKey: 'planStatus',
    header: 'PLAN STATUS',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <div
          key={row?.latestUserSubscription?.subscriptionPlan?.id}
          className="me-1"
        >
          {row?.latestUserSubscription?.status}
        </div>
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <div key={row?.userSubscription?.subscriptionPlan?.id} className="me-1">
    //       {row?.userSubscription?.status}
    //     </div>
    //   ) : row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id ? (
    //     <div
    //       key={row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id}
    //       className="me-1"
    //     >
    //       {row?.latestDeactivatedUserSubscription?.status}
    //     </div>
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },

  {
    accessorKey: 'dedicatedRM?.firstName',
    header: 'ASSIGNED RM',
    cell: ({ row }) => (
      <div>
        {row?.original?.dedicatedRM?.firstName
          ? `${row?.original?.dedicatedRM?.firstName} ${row?.original?.dedicatedRM?.lastName}`
          : 'N/A'}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'phone',
    header: 'PHONE NUMBER',
    cell: ({ row }) => (
      <div>
        {`${row?.original?.callingCode?.callingCode}-${row?.original?.phone}`}
      </div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: 'osType',
    header: 'OS TYPE',
    cell: ({ row }) => (
      <>
        {row?.original?.userDevices?.length > 0
          ? row?.original?.userDevices?.map((device, i) => {
            // Show osType for Android/iOS, show platform for WEB
            const displayValue = device?.osType
              ? device?.osType
              : (device?.platform === 'WEB' ? device?.platform : 'N/A');
            return <div key={i}>{displayValue}</div>;
          })
          : 'N/A'}
      </>
    ),
    sort: false,
  },
  {
    accessorKey: 'appVersion',
    header: 'APP VERSION',
    cell: ({ row }) => (
      <>
        {row?.original?.userDevices?.length > 0
          ? row?.original?.userDevices?.map((device, i) => {
            // Don't show N/A for WEB platform, show version only for APPLICATION
            if (device?.platform === 'WEB') {
              return <div key={i} />;
            }
            return (
              <div key={i}>
                {device?.appVersion ? device?.appVersion : 'N/A'}
              </div>
            );
          })
          : 'N/A'}
      </>
    ),
    sort: false,
  },

  // { accessorKey: 'tradeGstIn', header: 'GST', enableSorting: true },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
  {
    accessorKey: 'isWhatsappSubscribed',
    header: 'Whatsapp Msg',
    enableSorting: true,
  },
  { accessorKey: 'tdsEligible', header: 'TDS ELIGIBLE', enableSorting: true },
  { accessorKey: 'userStatus', header: 'User Status', enableSorting: false },
  {
    accessorKey: 'dailyPriceOptOut',
    header: 'Daily Price',
    enableSorting: false
  },
  {
    accessorKey: 'commissionType',
    header: 'SELLER COMMISSION TYPE',
    cell: ({ row }) => {
      return (
        <CommissionTypeSelector
          id={`commission-type-${row.id}`}
          rowData={row.original}
          type="SELLER"
        />
      );
    },
    enableSorting: false,
  },
  {
    accessorKey: 'commissionType',
    header: 'BUYER COMMISSION TYPE',
    cell: ({ row }) => {
      if (row.original?.userSubscription) {
        return <p className="text-center">Subscribed</p>;
      }
      return (
        <CommissionTypeSelector
          id={`commission-type-${row.original.id || row.id}`}
          rowData={row.original}
          type="BUYER"
        />
      );
    },
    enableSorting: false,
  },
  {
    accessorKey: 'paymentTerms',
    header: 'PAYMENT TERMS',
    enableSorting: false,
  },
  { accessorKey: 'kycStatus', header: 'KYC STATUS', enableSorting: true },
  { accessorKey: 'role', header: 'Role', enableSorting: false },
  { accessorKey: 'actions', header: '', enableSorting: true },
];

export const foreignVendorColumns = [
  {
    id: 'select',
    header: ({ table }) => (
      <>
        <IndeterminateCheckbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
      </>
    ),
    cell: ({ row }) => (
      <div className="px-1">
        <IndeterminateCheckbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler(),
          }}
        />
      </div>
    ),
  },
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'flag',
    header: 'FLAG',
    cell: ({ row }) => renderFlagCell(row),
    enableSorting: false,
  },
  { accessorKey: 'id', header: 'ID', enableSorting: true },

  {
    accessorKey: 'firstName',
    header: 'VENDOR',
    // cell: ({ row }) => (
    //   <UserInfo
    //     name={`${row?.original?.firstName} ${
    //       row?.original?.lastName ? row?.original?.lastName : ''
    //     }`}
    //     mobileNumber={row?.original?.phone}
    //   />
    // ),
    enableSorting: true,
  },
  {
    accessorKey: 'tradeName',
    header: 'BUSINESS NAME',
    cell: ({ row }) => (
      <>
        {row?.original?.tradeName || row?.original?.entityName ? (
          <UserInfo
            name={row?.original?.tradeName || row?.original?.entityName || ''}
            gstNumber={row?.original?.tradeGstIn}
          />
        ) : (
          'N/A'
        )}
      </>
    ),
    enableSorting: true,
  },
  // {
  //   accessorKey: 'isParentTrader',
  //   header: 'Parent Trader',
  //   cell: ({ row }) => (
  //     <>
  //       {row?.original?.isParentTrader ? (
  //         'N/A'
  //       ) : (
  //         <div>
  //           {row?.original?.parentTrader?.firstName +
  //             ' ' +
  //             row?.original?.parentTrader?.lastName}
  //         </div>
  //       )}
  //     </>
  //   ),
  //   enableSorting: false,
  // },

  {
    accessorKey: 'demandCount',
    header: 'DEMAND COUNT',
    enableSorting: false,
  },
  {
    accessorKey: 'latestUserSubscription',
    header: 'PLAN',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <div
          key={row?.latestUserSubscription?.subscriptionPlan?.id}
          className="me-1"
        >
          <UserInfo
            name={row?.latestUserSubscription?.subscriptionPlan?.planName}
            gstNumber={moment(
              row?.latestUserSubscription?.deactivationDate,
            ).format('D MMM, YYYY')}
          />
        </div>
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <div key={row?.userSubscription?.subscriptionPlan?.id} className="me-1">
    //       <UserInfo
    //         name={row?.userSubscription?.subscriptionPlan?.planName}
    //         gstNumber={moment(row?.userSubscription?.deactivationDate).format(
    //           'D MMM, YYYY',
    //         )}
    //       />
    //     </div>
    //   ) : row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id ? (
    //     <div
    //       key={row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id}
    //       className="me-1"
    //     >
    //       <UserInfo
    //         name={
    //           row?.latestDeactivatedUserSubscription?.subscriptionPlan?.planName
    //         }
    //         gstNumber={moment(
    //           row?.latestDeactivatedUserSubscription?.deactivationDate,
    //         ).format('D MMM, YYYY')}
    //       />
    //     </div>
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorKey: 'latestUserSubscription?.activationDate',
    header: 'Plan Activation Date',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <DateFormatter dateTime={row?.latestUserSubscription?.activationDate} />
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <DateFormatter dateTime={row?.userSubscription?.activationDate} />
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorKey: 'planStatus',
    header: 'PLAN STATUS',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <div
          key={row?.latestUserSubscription?.subscriptionPlan?.id}
          className="me-1"
        >
          {row?.latestUserSubscription?.status}
        </div>
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <div key={row?.userSubscription?.subscriptionPlan?.id} className="me-1">
    //       {row?.userSubscription?.status}
    //     </div>
    //   ) : row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id ? (
    //     <div
    //       key={row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id}
    //       className="me-1"
    //     >
    //       {row?.latestDeactivatedUserSubscription?.status}
    //     </div>
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },

  {
    accessorKey: 'dedicatedRM?.firstName',
    header: 'ASSIGNED RM',
    cell: ({ row }) => (
      <div>
        {row?.original?.dedicatedRM?.firstName
          ? `${row?.original?.dedicatedRM?.firstName} ${row?.original?.dedicatedRM?.lastName}`
          : 'N/A'}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'callingCode.country',
    header: 'Country',
    cell: ({ row }) => <div>{row?.original?.callingCode?.country}</div>,
    enableSorting: false,
  },
  {
    accessorKey: 'phone',
    header: 'PHONE NUMBER',
    cell: ({ row }) => (
      <div>
        {`${row?.original?.callingCode?.callingCode}-${row?.original?.phone}`}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'osType',
    header: 'OS TYPE',
    cell: ({ row }) => (
      <>
        {row?.original?.userDevices?.length > 0
          ? row?.original?.userDevices?.map((device, i) => {
            // Show osType for Android/iOS, show platform for WEB
            const displayValue = device?.osType
              ? device?.osType
              : (device?.platform === 'WEB' ? device?.platform : 'N/A');
            return <div key={i}>{displayValue}</div>;
          })
          : 'N/A'}
      </>
    ),
    sort: false,
  },
  {
    accessorKey: 'appVersion',
    header: 'APP VERSION',
    cell: ({ row }) => (
      <>
        {row?.original?.userDevices?.length > 0
          ? row?.original?.userDevices?.map((device, i) => {
            // Don't show N/A for WEB platform, show version only for APPLICATION
            if (device?.platform === 'WEB') {
              return <div key={i} />;
            }
            return (
              <div key={i}>
                {device?.appVersion ? device?.appVersion : 'N/A'}
              </div>
            );
          })
          : 'N/A'}
      </>
    ),
    sort: false,
  },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
  {
    accessorKey: 'isWhatsappSubscribed',
    header: 'Whatsapp Msg',
    enableSorting: true,
  },
  { accessorKey: 'tdsEligible', header: 'TDS ELIGIBLE', enableSorting: true },
  { accessorKey: 'userStatus', header: 'Status', enableSorting: false },
  {
    accessorKey: 'paymentTerms',
    header: 'PAYMENT TERMS',
    enableSorting: false,
  },
  { accessorKey: 'kycStatus', header: 'KYC STATUS', enableSorting: true },
  { accessorKey: 'role', header: 'Role', enableSorting: false },
  { accessorKey: 'actions', header: '', enableSorting: true },
];

export const vendorWithDeleteColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'flag',
    header: 'FLAG',
    cell: ({ row }) => renderFlagCell(row),
    enableSorting: false,
  },
  { accessorKey: 'id', header: 'ID', enableSorting: true },

  {
    accessorKey: 'firstName',
    header: 'VENDOR',
    // cell: ({ row }) => (
    //   <UserInfo
    //     name={`${row?.original?.firstName} ${
    //       row?.original?.lastName ? row?.original?.lastName : ''
    //     }`}
    //     mobileNumber={row?.original?.phone}
    //   />
    // ),
    enableSorting: true,
  },
  {
    accessorKey: 'tradeName',
    header: 'BUSINESS NAME',
    cell: ({ row }) => (
      <>
        {row?.original?.tradeName || row?.original?.entityName ? (
          <UserInfo
            name={row?.original?.tradeName || row?.original?.entityName || ''}
            gstNumber={row?.original?.tradeGstIn}
          />
        ) : (
          'N/A'
        )}
      </>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'latestUserSubscription',
    header: 'PLAN',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <div
          key={row?.latestUserSubscription?.subscriptionPlan?.id}
          className="me-1"
        >
          <UserInfo
            name={row?.latestUserSubscription?.subscriptionPlan?.planName}
            gstNumber={moment(
              row?.latestUserSubscription?.deactivationDate,
            ).format('D MMM, YYYY')}
          />
        </div>
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <div key={row?.userSubscription?.subscriptionPlan?.id} className="me-1">
    //       <UserInfo
    //         name={row?.userSubscription?.subscriptionPlan?.planName}
    //         gstNumber={moment(row?.userSubscription?.deactivationDate).format(
    //           'D MMM, YYYY',
    //         )}
    //       />
    //     </div>
    //   ) : row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id ? (
    //     <div
    //       key={row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id}
    //       className="me-1"
    //     >
    //       <UserInfo
    //         name={
    //           row?.latestDeactivatedUserSubscription?.subscriptionPlan?.planName
    //         }
    //         gstNumber={moment(
    //           row?.latestDeactivatedUserSubscription?.deactivationDate,
    //         ).format('D MMM, YYYY')}
    //       />
    //     </div>
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorKey: 'planStatus',
    header: 'PLAN STATUS',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <div
          key={row?.latestUserSubscription?.subscriptionPlan?.id}
          className="me-1"
        >
          {row?.latestUserSubscription?.status}
        </div>
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <div key={row?.userSubscription?.subscriptionPlan?.id} className="me-1">
    //       {row?.userSubscription?.status}
    //     </div>
    //   ) : row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id ? (
    //     <div
    //       key={row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id}
    //       className="me-1"
    //     >
    //       {row?.latestDeactivatedUserSubscription?.status}
    //     </div>
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorKey: 'traderPhone',
    header: 'PHONE NUMBER',
    cell: ({ row }) => (
      <div>
        {`${row?.original?.traderPhone ? `${row?.original?.callingCode?.callingCode}-${row?.original?.traderPhone}` : 'N/A'}`}
      </div>
    ),
    enableSorting: true,
  },

  // { accessorKey: 'tradeGstIn', header: 'GST', enableSorting: true },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
  { accessorKey: 'status', header: 'STATUS', enableSorting: true },
];

export const foreignvendorWithDeleteColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'flag',
    header: 'FLAG',
    cell: ({ row }) => renderFlagCell(row),
    enableSorting: false,
  },
  { accessorKey: 'id', header: 'ID', enableSorting: true },

  {
    accessorKey: 'firstName',
    header: 'VENDOR',
    // cell: ({ row }) => (
    //   <UserInfo
    //     name={`${row?.original?.firstName} ${
    //       row?.original?.lastName ? row?.original?.lastName : ''
    //     }`}
    //     mobileNumber={row?.original?.phone}
    //   />
    // ),
    enableSorting: true,
  },
  {
    accessorKey: 'tradeName',
    header: 'BUSINESS NAME',
    cell: ({ row }) => (
      <>
        {row?.original?.tradeName || row?.original?.entityName ? (
          <UserInfo
            name={row?.original?.tradeName || row?.original?.entityName || ''}
            gstNumber={row?.original?.tradeGstIn}
          />
        ) : (
          'N/A'
        )}
      </>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'latestUserSubscription',
    header: 'PLAN',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <div
          key={row?.latestUserSubscription?.subscriptionPlan?.id}
          className="me-1"
        >
          <UserInfo
            name={row?.latestUserSubscription?.subscriptionPlan?.planName}
            gstNumber={moment(
              row?.latestUserSubscription?.deactivationDate,
            ).format('D MMM, YYYY')}
          />
        </div>
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <div key={row?.userSubscription?.subscriptionPlan?.id} className="me-1">
    //       <UserInfo
    //         name={row?.userSubscription?.subscriptionPlan?.planName}
    //         gstNumber={moment(row?.userSubscription?.deactivationDate).format(
    //           'D MMM, YYYY',
    //         )}
    //       />
    //     </div>
    //   ) : row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id ? (
    //     <div
    //       key={row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id}
    //       className="me-1"
    //     >
    //       <UserInfo
    //         name={
    //           row?.latestDeactivatedUserSubscription?.subscriptionPlan?.planName
    //         }
    //         gstNumber={moment(
    //           row?.latestDeactivatedUserSubscription?.deactivationDate,
    //         ).format('D MMM, YYYY')}
    //       />
    //     </div>
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorKey: 'planStatus',
    header: 'PLAN STATUS',
    accessorFn: (row) => {
      return row?.latestUserSubscription?.id ? (
        <div
          key={row?.latestUserSubscription?.subscriptionPlan?.id}
          className="me-1"
        >
          {row?.latestUserSubscription?.status}
        </div>
      ) : (
        'N/A'
      );
    },
    // accessorFn: (row) => {
    //   return row?.userSubscription?.id ? (
    //     <div key={row?.userSubscription?.subscriptionPlan?.id} className="me-1">
    //       {row?.userSubscription?.status}
    //     </div>
    //   ) : row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id ? (
    //     <div
    //       key={row?.latestDeactivatedUserSubscription?.subscriptionPlan?.id}
    //       className="me-1"
    //     >
    //       {row?.latestDeactivatedUserSubscription?.status}
    //     </div>
    //   ) : (
    //     'N/A'
    //   );
    // },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorKey: 'callingCode?.country',
    header: 'Country',
    cell: ({ row }) => <div>{row?.original?.callingCode?.country}</div>,
    enableSorting: false,
  },
  {
    accessorKey: 'traderPhone',
    header: 'PHONE NUMBER',
    cell: ({ row }) => (
      <div>
        {`${row?.original?.traderPhone ? `${row?.original?.callingCode?.callingCode}-${row?.original?.traderPhone}` : 'N/A'}`}
      </div>
    ),
    enableSorting: true,
  },

  // { accessorKey: 'tradeGstIn', header: 'GST', enableSorting: true },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
  { accessorKey: 'status', header: 'STATUS', enableSorting: true },
];

export const transactionsColumns = [
  { accessorKey: '', header: 'BUYER', enableSorting: true },
  { accessorKey: '', header: 'LOCATION', enableSorting: true },
  { accessorKey: '', header: "BUYER'S BID", enableSorting: true },
  { accessorKey: '', header: "SELLER'S BID", enableSorting: true },
  { accessorKey: '', header: 'VALIDTY', enableSorting: true },
];

export const ordersColumns = [
  { accessorKey: 'id', header: 'ORDER ID', enableSorting: true },
  {
    accessorKey: '',
    header: 'LOCATION',
    cell: ({ row }) => (
      <>
        <div className="mb-1">
          {row?.original?.seller?.addresses[0]?.city?.cityName}
        </div>
        <div className="font-manrope text-active">
          {row?.original?.seller?.addresses[0]?.state?.stateName}
        </div>
      </>
    ),
    enableSorting: true,
  },
  { accessorKey: 'grade.name', header: 'GRADE', enableSorting: true },
  { accessorKey: 'quantity', header: 'ORDERED', enableSorting: true },
  { accessorKey: 'rate', header: 'RATE', enableSorting: true },
  { accessorKey: 'status', header: '', enableSorting: true },
];

export const paymentsColumns = [
  { accessorKey: '', header: 'ORDER ID', enableSorting: true },
  { accessorKey: '', header: 'LOCATION', enableSorting: true },
  { accessorKey: '', header: 'GRADE', enableSorting: true },
  { accessorKey: '', header: 'PAID', enableSorting: true },
  { accessorKey: '', header: 'PENDING', enableSorting: true },
];

export const demandsColumns = [
  { accessorKey: 'id', header: 'DEMAND ID', sort: true },
  {
    accessorKey: '',
    header: 'LOCATION',
    cell: ({ row }) => (
      <>
        <div className="mb-1">{row?.original?.city?.cityName}</div>
        <div className="font-manrope text-active">
          {row?.original?.state?.stateName}
        </div>
      </>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'grades',
    header: 'GRADE',
    accessorFn: (row) => {
      return row?.grades?.map((grade) => {
        return (
          <Badge key={grade?.id} color="primary" className="me-1">
            {grade?.name}
          </Badge>
        );
      });
    },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  { accessorKey: 'rate', header: 'RATE', sort: true },
  // { accessorKey: '', header: 'MLQ', sort: true },
];

export const offersColumns = [
  { accessorKey: 'id', header: 'OFFER ID', sort: true },
  {
    accessorKey: '',
    header: 'LOCATION',
    cell: ({ row }) => (
      <>
        <div className="mb-1">{row?.original?.city?.cityName}</div>
        <div className="font-manrope text-active">
          {row?.original?.state?.stateName}
        </div>
      </>
    ),
    enableSorting: false,
  },
  {
    accessorKey: 'grade.name',
    header: 'GRADE',
    cell: ({ row }) => (
      <Badge color="primary">{row?.original?.grade?.name}</Badge>
    ),
    enableSorting: false,
  },
  { accessorKey: 'rate', header: 'RATE', sort: true },
  { accessorKey: 'minimumQty', header: 'MOQ', sort: true },
];

export const BillingAndPaymentColumns = [
  {
    accessorKey: 'id',
    header: 'Subscription ID',
    enableSorting: true,
  },
  {
    accessorKey: 'userSubscription.subscriptionPlan.planName',
    header: 'Plan',
    cell: ({ row }) => (
      <>
        {row?.original?.addOnPlan?.id ? (
          <UserInfo
            name={row?.original?.addOnPlan?.planName}
            gstNumber="Base Plan"
          />
        ) : row?.original?.userSubscription?.id ? (
          <UserInfo
            name={row?.original?.userSubscription?.subscriptionPlan?.planName}
            gstNumber={`${row?.original?.userSubscription?.subscriptionPlan?.duration} days`}
          />
        ) : (
          'N/A'
        )}
      </>
    ),
    enableSorting: false,
  },

  {
    accessorKey: 'grandTotal',
    header: 'Amount',
    cell: ({ row }) => (
      <div>
        {row?.original?.grandTotal === null
          ? 'Not Available'
          : `${currencyToLocal(
            row?.original?.grandTotal || 0,
            row?.original?.currency,
          )}`}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'createdAt',
    header: 'DATE',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
  {
    accessorKey: 'deactivationDate',
    header: 'EXPIRY DATE',
    cell: ({ row }) =>
      row?.original?.userSubscription?.deactivationDate ? (
        <DateFormatter
          dateTime={row?.original?.userSubscription?.deactivationDate}
        />
      ) : (
        'N/A'
      ),
    enableSorting: true,
  },
  // {
  //   accessorKey: 'paymentGateway',
  //   header: 'Mode of Payment',
  //   enableSorting: true,
  // },
  { accessorKey: 'actions', header: 'Invoice', enableSorting: false },
];

// export const SellerCommissionHistoryColumns = [
//   {
//     accessorKey: 'sellerName',
//     header: 'Seller Name',
//     cell: ({ row }) => (
//       <div>{row?.original?.sellerName ? row?.original?.sellerName : 'N/A'}</div>
//     ),
//     enableSorting: false,
//   },
//   {
//     accessorKey: 'year',
//     header: 'Year',
//     enableSorting: false,
//   },
//   {
//     accessorKey: 'month',
//     header: 'Month',
//     enableSorting: false,
//   },
//   {
//     accessorKey: 'qty',
//     header: 'Quantity',
//     cell: ({ row }) => (
//       <div>
//         {row?.original?.qty} {row?.original?.qtyUnit}
//       </div>
//     ),
//     enableSorting: false,
//   },

//   {
//     accessorKey: 'amount',
//     header: 'Commission',
//     cell: ({ row }) => (
//       <div>
//         {currencyToLocal(row?.original?.amount, row?.original?.currency)}
//       </div>
//     ),
//     enableSorting: false,
//   },
// ];

export const SellerCommissionHistoryColumns = [
  {
    accessorKey: 'SNo',
    header: 'S.NO.',
    enableSorting: false,
  },
  // {
  //   accessorKey: 'year',
  //   header: 'Year',
  //   enableSorting: false,
  // },
  {
    accessorKey: 'month',
    header: 'Month',
    enableSorting: false,
  },
  {
    accessorKey: 'totalQty',
    header: 'Quantity',
    cell: ({ row }) => (
      <div>
        {row?.original?.totalQty} {row?.original?.qtyUnit}
      </div>
    ),
    enableSorting: false,
  },

  {
    accessorKey: 'totalAmount',
    header: 'Commission',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(row?.original?.totalAmount, row?.original?.rateUnit)}
      </div>
    ),
    enableSorting: false,
  },
];

export const childSellerCommissionHistoryColumns = [
  {
    accessorKey: 'SNo',
    header: 'S.NO.',
    enableSorting: false,
  },
  {
    accessorKey: 'sellerName',
    header: 'Seller Name',
    enableSorting: false,
  },
  {
    accessorKey: 'totalQty',
    header: 'Quantity',
    cell: ({ row }) => (
      <div>
        {row?.original?.totalQty} {row?.original?.qtyUnit}
      </div>
    ),
    enableSorting: false,
  },

  {
    accessorKey: 'totalAmount',
    header: 'Commission',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(row?.original?.totalAmount, row?.original?.rateUnit)}
      </div>
    ),
    enableSorting: false,
  },
];

export const subChildSellerCommissionHistoryColumns = [
  {
    accessorKey: 'orderId',
    header: 'Order ID',
    enableSorting: false,
  },
  {
    accessorKey: 'orderDate',
    header: 'Date',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.orderDate} />,
    enableSorting: false,
  },
  {
    accessorKey: 'qty',
    header: 'Quantity',
    cell: ({ row }) => (
      <div>
        {row?.original?.qty} {row?.original?.qtyUnit}
      </div>
    ),
    enableSorting: false,
  },

  {
    accessorKey: 'amount',
    header: 'Commission',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(row?.original?.amount, row?.original?.rateUnit)}
      </div>
    ),
    enableSorting: false,
  },
];

export const getUpdatedVendorValues = (val) => {
  let values = { ...val };
  // if (values?.__typename) delete values?.__typename;
  // if (values?.createdAt) delete values?.createdAt;

  // if (values?.kyc) {
  //   delete values.kyc.__typename;
  //   delete values.kyc.createdAt;
  //   delete values.kyc.updatedAt;
  // }

  if (values?.addresses?.length) {
    values = {
      ...values,
      addresses: values.addresses
        .filter((item) =>
          (item.street && item.street.trim() !== '') ||
          (item.pinCode && String(item.pinCode).trim() !== '') ||
          item.city || item.state || item.country
        )
        .map((item) => {
          return {
            id: item.id,
            city: item.city?.id,
            state: item.state?.id,
            country: item.country?.id,
            street: item.street,
            pinCode: item?.pinCode,
          };
        }),
    };
  } else {
    delete values.addresses;
  }

  return {
    ...values,
    callingCode: values.callingCode?.id,

    // isKycVerified: val.isKycVerified?.id,
  };
};
export const vendorInitialValues = {
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  // isKycVerified: '',
  kycStatus: 'KYC_PENDING',
  // phone_code: '',
  phone: '',
  // kyc: {
  //   aadharFront: '',
  //   aadharBack: '',
  //   panPhoto: '',
  //   gstPhoto: '',
  // },
  callingCode: '',
  roles: [3],
  addresses: [{ street: '', country: '', state: '', city: '' }],
  // addresses: null,
};

export const getVendorInitialValues = (val) => {
  return {
    // ...val,
    id: val?.id,
    addresses: val.addresses?.filter(address =>
      (address.street && address.street.trim() !== '') ||
      (address.pinCode && String(address.pinCode).trim() !== '') ||
      address.city || address.state || address.country
    ) || [],
    firstName: val.firstName,
    middleName: val.middleName,
    phone: val.phone,
    lastName: val.lastName,
    kycStatus: val.kycStatus,
    email: val.email,
    status: val.status,
    tradeGstIn: val.tradeGstIn,
    tradeName: val.tradeName,
    // kyc: val.kyc
    //   ? {
    //       aadharBack: val.kyc.aadharBack,
    //       aadharFront: val.kyc.aadharFront,
    //       aadharNumber: val.kyc.aadharNumber,
    //       aadharStatus: val.kyc.aadharStatus,
    //       gstLocation: val.kyc.gstLocation,
    //       gstNumber: val.kyc.gstNumber,
    //       gstPhoto: val.kyc.gstPhoto,
    //       gstStatus: val.kyc.gstStatus,
    //       id: val.kyc.id,
    //       panNumber: val.kyc.panNumber,
    //       panPhoto: val.kyc.panPhoto,
    //       panStatus: val.kyc.panStatus,
    //     }
    //   : null,
    callingCode: { id: val?.callingCode?.id, label: val?.callingCode?.id },
    // isKycVerified: { id: val?.isKycVerified, label: val?.isKycVerified },
  };
};

export const VENDORS_TABS = {
  BIDS: 'Bids',
  PAYMENTS: 'Payments',
  ORDERS: 'Orders',
  MY_OFFERS: 'Offers',
  MY_DEMANDS: 'Demands',
  HISTORY: 'History',
  FAVOURITE_GRADE: 'Favourite Grade',
  FAVOURITE_LOCATION: 'Favourite Location',
};

export const VENDOR_TYPES = {
  INDIAN: 'Indian',
  FOREIGN: 'Foreign',
};

export const KYC_STATUS_FILTER = {
  ALL: 'ALL',
  KYC_ACCEPTED: 'KYC_ACCEPTED',
  KYC_PENDING: 'KYC_PENDING',
  KYC_REJECTED: 'KYC_REJECTED',
  VENDOR_DELETED: 'Deleted',
};

// export const getSubscriberFilter = (typeList) => {
//   // console.log('typeList', val, list);

//   // let typeList = [val];
//   // if (list.length > 0) typeList = [...list];
//   let filter = [];
//   if (typeList.length > 0) {
//     typeList.map((type) => {
//       if (type === 'subscribers')
//         filter = [
//           ...filter,
//           {
//             key: 'status',
//             value: 'ACTIVE',
//             type: 'STRING',
//             op: 'EQ',
//             setAttribute: 'userSubscriptions',
//           },
//         ];
//       if (type === 'paidSubscribers')
//         filter = [
//           ...filter,
//           // {
//           //   key: 'status',
//           //   value: 'ACTIVE',
//           //   type: 'STRING',
//           //   op: 'EQ',
//           //   setAttribute: 'userSubscriptions',
//           // },
//           {
//             key: 'isTrial',
//             value: true,
//             type: 'BOOLEAN',
//             op: 'NEQ',
//             setAttribute: 'userSubscriptions',
//             addKey: 'status',
//             addValue: 'ACTIVE',
//             logicalOp: 'AND',
//           },
//         ];
//       if (type === 'freeSubscribers')
//         filter = [
//           ...filter,
//           // {
//           //   key: 'status',
//           //   value: 'ACTIVE',
//           //   type: 'STRING',
//           //   op: 'EQ',
//           //   setAttribute: 'userSubscriptions',
//           // },
//           {
//             key: 'isTrial',
//             value: true,
//             type: 'BOOLEAN',
//             op: 'EQ',
//             setAttribute: 'userSubscriptions',
//             addKey: 'status',
//             addValue: 'ACTIVE',
//             logicalOp: 'AND',
//           },
//         ];

//       if (type === 'polylite')
//         filter = [
//           ...filter,
//           {
//             key: 'planName',
//             value: 'Poly-lite',
//             type: 'STRING',
//             op: 'LIKE',
//             setAttribute: 'userSubscriptions',
//             joinAttributeName: 'subscriptionPlan',
//             logicalOp: 'AND',
//             addKey: 'status',
//             addValue: 'ACTIVE',
//           },
//         ];

//       if (type === 'polymax')
//         filter = [
//           ...filter,
//           {
//             key: 'planName',
//             value: 'Poly-max',
//             type: 'STRING',
//             op: 'LIKE',
//             setAttribute: 'userSubscriptions',
//             joinAttributeName: 'subscriptionPlan',
//             logicalOp: 'AND',
//             addKey: 'status',
//             addValue: 'ACTIVE',
//           },
//         ];
//     });
//   }
//   return filter;
//   // if (type === 'paidSubscribers')
//   //   return [
//   //     {
//   //       key: 'status',
//   //       value: 'ACTIVE',
//   //       type: 'STRING',
//   //       op: 'EQ',
//   //       setAttribute: 'userSubscriptions',
//   //     },
//   //     {
//   //       key: 'isTrial',
//   //       value: true,
//   //       type: 'BOOLEAN',
//   //       op: 'NEQ',
//   //       setAttribute: 'userSubscriptions',
//   //       addKey: 'status',
//   //       addValue: 'ACTIVE',
//   //       logicalOp: 'AND',
//   //     },
//   //   ];

//   // if (type === 'freeSubscribers')
//   //   return [
//   //     {
//   //       key: 'status',
//   //       value: 'ACTIVE',
//   //       type: 'STRING',
//   //       op: 'EQ',
//   //       setAttribute: 'userSubscriptions',
//   //     },
//   //     {
//   //       key: 'isTrial',
//   //       value: true,
//   //       type: 'BOOLEAN',
//   //       op: 'NEQ',
//   //       setAttribute: 'userSubscriptions',
//   //       addKey: 'status',
//   //       addValue: 'ACTIVE',
//   //       logicalOp: 'AND',
//   //     },
//   //   ];
//   // if (type === 'subscribers')
//   //   return [
//   //     {
//   //       key: 'status',
//   //       value: 'ACTIVE',
//   //       type: 'STRING',
//   //       op: 'EQ',
//   //       setAttribute: 'userSubscriptions',
//   //     },
//   //   ];

//   // return [];
// };

const getDateRange = (days = 0) => {
  return `${currentDatePlusDaysToEpoch()},${currentDatePlusDaysToEpoch(days)}`;
};
export const getPlanExpiringFilter = (days) => {
  if (days > 0)
    return [
      {
        key: 'deactivationDate',
        value: getDateRange(days),
        setAttribute: 'userSubscriptions',
        type: 'DATE',
        op: 'BTW',
        logicalOp: 'AND',
        addKey: 'status',
        addValue: 'ACTIVE',
      },
    ];
  return [];
};

export const getCheckedIds = ({ subscriberType, checkboxes }) => {
  if (subscriberType === 'subscribers')
    return checkboxes
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.id);

  return [];
};

export const getSubscriberFilter = (typeList) => {
  const filter = [];

  const addActiveFilter = () => ({
    key: 'status',
    value: 'ACTIVE',
    type: 'STRING',
    op: 'EQ',
    setAttribute: 'userSubscriptions',
  });

  const addIsTrialFilter = (values, op) => ({
    key: 'isTrial',
    value: values,
    type: 'BOOLEAN',
    op,
    setAttribute: 'userSubscriptions',
    addKey: 'status',
    addValue: 'ACTIVE',
    logicalOp: 'AND',
  });

  const addIsPlanNameFilter = (planName) => ({
    key: 'planName',
    value: planName,
    type: 'STRING',
    op: 'IN',
    setAttribute: 'userSubscriptions',
    joinAttributeName: 'subscriptionPlan',
    logicalOp: 'AND',
    addKey: 'status',
    addValue: 'ACTIVE',
  });

  // Flag to indicate if both freeSubscribers and paidSubscribers are present
  const hasBothFreeAndPaid =
    typeList.includes('freeSubscribers') &&
    typeList.includes('paidSubscribers');

  const hasBothPolyLiteAndPolyMax =
    typeList.includes('polymax') && typeList.includes('polylite');

  typeList.forEach((type) => {
    switch (type) {
      case 'subscribers':
        if (!hasBothFreeAndPaid) {
          filter.push(addActiveFilter());
        }
        break;
      case 'paidSubscribers':
        if (!hasBothFreeAndPaid) {
          filter.push(addIsTrialFilter(false, 'EQ'));
        }
        break;
      case 'freeSubscribers':
        if (!hasBothFreeAndPaid) {
          filter.push(addIsTrialFilter(true, 'EQ'));
        }
        break;
      case 'polylite':
        if (!hasBothPolyLiteAndPolyMax) {
          filter.push(addIsPlanNameFilter('Poly-Lite'));
        }
        // filter.push({
        //   key: 'planName',
        //   value: 'Poly-Lite',
        //   type: 'STRING',
        //   op: 'LIKE',
        //   setAttribute: 'userSubscriptions',
        //   joinAttributeName: 'subscriptionPlan',
        //   logicalOp: 'AND',
        //   addKey: 'status',
        //   addValue: 'ACTIVE',
        // });
        break;
      case 'polymax':
        if (!hasBothPolyLiteAndPolyMax) {
          filter.push(addIsPlanNameFilter('Poly-Max'));
        }
        break;

      case 'NonRegistered':
        filter.push({
          key: 'isNonRegistered',
          value: 'true',
          type: 'BOOLEAN',
          op: 'EQ',
        });
        break;
      case 'phoneOnlyUsers':
        filter.push({
          key: 'phoneOnlyUsers',
          value: 'true',
          type: 'BOOLEAN',
          op: 'EQ',
        });
        break;
      case 'deleted':
        filter.push({
          key: 'isDeleted',
          value: 'true',
          type: 'BOOLEAN',
          op: 'EQ',
        });
        break;
      case 'Suspended':
        filter.push(
          { key: 'status', value: 'SUSPENDED', type: 'STRING', op: 'EQ' },
          { key: 'isDeleted', value: 'true', type: 'BOOLEAN', op: 'EQ' },
        );
        break;
      case 'Inactive':
        filter.push({
          key: 'favoriteGradeStatus',
          value: 'INACTIVE',
          type: 'STRING',
          op: 'EQ',
        });
        break;
      case 'Active':
        filter.push({
          key: 'favoriteGradeStatus',
          value: 'ACTIVE',
          type: 'STRING',
          op: 'EQ',
        });
        break;
      default:
        break;
    }
  });

  // Special handling if both freeSubscribers and paidSubscribers are present
  if (hasBothFreeAndPaid) {
    const cleanFilter = filter.filter(
      (f) => !(f.key === 'isTrial' && f.op === 'EQ'),
    );
    cleanFilter.push(addActiveFilter());
    cleanFilter.push(addIsTrialFilter('true,false', 'IN'));
    return cleanFilter;
  }

  if (hasBothPolyLiteAndPolyMax) {
    const cleanFilter = filter.filter((f) => !(f.key === 'planName'));
    cleanFilter.push(addIsPlanNameFilter('Poly-Lite,Poly-Max'));
    return cleanFilter;
  }

  return filter;
};

export const getInactiveSubscriberFilter = (typeList) => {
  const filter = [];

  const addActiveFilter = () => ({
    key: 'status',
    value: 'ACTIVE,INACTIVE',
    type: 'STRING',
    op: 'NOT_IN_STATUS',
    setAttribute: 'userSubscriptions',
  });

  const addIsTrialFilter = (values, op) => ({
    key: 'isTrial',
    value: values,
    type: 'BOOLEAN',
    op,
    setAttribute: 'userSubscriptions',
    addKey: 'status',
    addValue: 'EXPIRED',
    logicalOp: 'AND',
  });

  const addIsPlanNameFilter = (planName) => ({
    key: 'planName',
    value: planName,
    type: 'STRING',
    op: 'IN',
    setAttribute: 'userSubscriptions',
    joinAttributeName: 'subscriptionPlan',
    logicalOp: 'AND',
    addKey: 'status',
    addValue: 'EXPIRED',
  });

  // Flag to indicate if both freeSubscribers and paidSubscribers are present
  const hasBothFreeAndPaid =
    typeList.includes('freeSubscribers') &&
    typeList.includes('paidSubscribers');

  const hasBothPolyLiteAndPolyMax =
    typeList.includes('polymax') && typeList.includes('polylite');

  typeList.forEach((type) => {
    switch (type) {
      case 'expireSubscribers':
        if (!hasBothFreeAndPaid) {
          filter.push(addActiveFilter());
        }
        break;
      case 'paidSubscribers':
        if (!hasBothFreeAndPaid) {
          filter.push(addIsTrialFilter(false, 'EQ'));
        }
        break;
      case 'freeSubscribers':
        if (!hasBothFreeAndPaid) {
          filter.push(addIsTrialFilter(true, 'EQ'));
        }
        break;
      case 'polylite':
        if (!hasBothPolyLiteAndPolyMax) {
          filter.push(addIsPlanNameFilter('Poly-Lite'));
        }
        // filter.push({
        //   key: 'planName',
        //   value: 'Poly-Lite',
        //   type: 'STRING',
        //   op: 'LIKE',
        //   setAttribute: 'userSubscriptions',
        //   joinAttributeName: 'subscriptionPlan',
        //   logicalOp: 'AND',
        //   addKey: 'status',
        //   addValue: 'ACTIVE',
        // });
        break;
      case 'polymax':
        if (!hasBothPolyLiteAndPolyMax) {
          filter.push(addIsPlanNameFilter('Poly-Max'));
        }
        break;

      default:
        break;
    }
  });

  // Special handling if both freeSubscribers and paidSubscribers are present
  if (hasBothFreeAndPaid) {
    const cleanFilter = filter.filter(
      (f) => !(f.key === 'isTrial' && f.op === 'EQ'),
    );
    cleanFilter.push(addActiveFilter());
    cleanFilter.push(addIsTrialFilter('true,false', 'IN'));
    return cleanFilter;
  }

  if (hasBothPolyLiteAndPolyMax) {
    const cleanFilter = filter.filter((f) => !(f.key === 'planName'));
    cleanFilter.push(addIsPlanNameFilter('Poly-Lite,Poly-Max'));
    return cleanFilter;
  }

  return filter;
};

// export const getSubscriberFilter = (typeList) => {
//   const filter = [];

//   const addActiveFilter = () => ({
//     key: 'status',
//     value: 'ACTIVE',
//     type: 'STRING',
//     op: 'EQ',
//     setAttribute: 'userSubscriptions',
//   });

//   const addIsTrialFilter = (values, op) => ({
//     key: 'isTrial',
//     value: values,
//     type: 'BOOLEAN',
//     op,
//     setAttribute: 'userSubscriptions',
//     addKey: 'status',
//     addValue: 'ACTIVE',
//     logicalOp: 'AND',
//   });

//   typeList.forEach((type) => {
//     switch (type) {
//       case 'subscribers':
//         filter.push(addActiveFilter());
//         break;
//       case 'paidSubscribers':
//         // filter.push(addActiveFilter());
//         filter.push(addIsTrialFilter(false, 'EQ'));
//         break;
//       case 'freeSubscribers':
//         // filter.push(addActiveFilter());
//         filter.push(addIsTrialFilter(true, 'EQ'));
//         break;
//       case 'polylite':
//         // filter.push(addActiveFilter());
//         filter.push({
//           key: 'planName',
//           value: 'Poly-lite',
//           type: 'STRING',
//           op: 'LIKE',
//           setAttribute: 'userSubscriptions',
//           joinAttributeName: 'subscriptionPlan',
//           logicalOp: 'AND',
//           addKey: 'status',
//           addValue: 'ACTIVE',
//         });
//         break;
//       case 'polymax':
//         // filter.push(addActiveFilter());
//         filter.push({
//           key: 'planName',
//           value: 'Poly-max',
//           type: 'STRING',
//           op: 'LIKE',
//           setAttribute: 'userSubscriptions',
//           joinAttributeName: 'subscriptionPlan',
//           logicalOp: 'AND',
//           addKey: 'status',
//           addValue: 'ACTIVE',
//         });
//         break;
//       default:
//         break;
//     }
//   });

//   // Special handling if both freeSubscribers and paidSubscribers are present
//   if (
//     typeList.includes('freeSubscribers') &&
//     typeList.includes('paidSubscribers')
//   ) {
//     filter.push(addActiveFilter());
//     filter.push(addIsTrialFilter('true,false', 'IN'));
//   }

//   return filter;
// };

export const TRADER_TYPES = {
  BUYER: 'BUYER',
  SELLER: 'SELLER',
};

export const isGstNumberAvailable = (gstNumber) => {
  if (!gstNumber) return false;

  const invalidGstValues = [
    'Not Available',
    'N/A',
    'NA',
    'null',
    'undefined',
    'not available',
    'n/a',
  ];

  return (
    !invalidGstValues.includes(gstNumber.toString().trim()) &&
    gstNumber.toString().trim().length > 0
  );
};
